export default __webpack_public_path__ + "static/media/logo-beat-the-stigma-2.2b01f679.png";